(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .directive('oddCampaign', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addCampaign = '&';
        directiveScope.isSurvey = '@';
        directiveScope.withOwner = '@';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/campaign/oddCampaign.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });
                    function initBoxModel() {
                        $scope.boxModel._stateLoading =
                            $scope.boxModel && $scope.boxModel.ProgressState &&
                            $scope.boxModel.ProgressState.Value === 'InProgress';

                        $scope.boxModel._isSurvey = $scope.isSurvey && $scope.isSurvey === 'true';

                        $scope.boxModel._isEditable =
                            !$scope.boxModel.ODDCampaignID
                            || (!$scope.boxModel._stateLoading
                                && _.get($scope, 'boxModel.ProgressStatus.Value') === 'Draft'
                                && !$scope.boxModel.HasResponses);
                    }
                    initBoxModel();

                    $scope.updateModel = function (newModel) {
                        $scope.boxModel = newModel;
                        initBoxModel();
                    };

                    $scope.goToCampaign = function (campaign) {
                        $scope.clickOnBox({ campaign: campaign });
                    };

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();